import { useEffect, useState } from 'react'
import useFirstRender from '../../hooks/FirstRender';
import LoadMore from '../../components/common/LoadMore';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useApiProgress } from '../../hooks/ApiProgress';
import { ENTITY_IS_IN_USE_MESSAGE } from '../../utils/constants';
import { toast } from 'react-toastify';
import Input from '../../components/Input';
import { AiFillDelete, AiFillEdit } from 'react-icons/ai';
import Button from '../../components/Button';
import { GoPlus } from 'react-icons/go';
import { onChange } from '../../utils/functions';
import DeleteModal from '../../components/DeleteModal';
import { OPERATION_PATH, deleteOperation, getPageOperations } from '../../api/operationApi';
import { deleteOperationAction, getOperationPageAction, setOperationPageAction } from '../../redux/feature/operationSlice';

const OperationListPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const isFirstRender = useFirstRender()
    const nav = useNavigate()
    const dispatch = useDispatch()
    const operationPage = useSelector(state => state.operation.page)
    const pendingApiCall = useApiProgress('get', `${OPERATION_PATH}/page`, false)
    const pendingApiCallDelete = useApiProgress('delete', `${OPERATION_PATH}`, false)
    const [searchParams, setSearchParams] = useState({
        id: "",
        code: "",
        name: ""
    })
    const [isOpen, setIsOpen] = useState(false)
    const [deleteId, setDeleteId] = useState(undefined)
    const [searchTimer, setSearchTimer] = useState();

    useEffect(() => {
        operationPage.content.length === 0 && loadOperations({ size: 20 })
    }, [])

    const onLoadMore = () => {
        if (!operationPage.last) {
            loadOperations({ ...searchParams, lastId: operationPage.content[operationPage.content.length - 1]?.id })
        }
    }

    useEffect(() => {
        !isFirstRender && searching(searchParams)
    }, [searchParams])

    const loadOperations = (params) => {
        !pendingApiCall &&
            getPageOperations(params)
                .then(res => {
                    dispatch(getOperationPageAction(res.data))
                })
    }

    const searching = async (params) => {
        if (searchTimer) clearTimeout(searchTimer);
        let timer = setTimeout(() => {
            getPageOperations(params)
                .then(res => {
                    dispatch(setOperationPageAction(res.data))
                })
        }, 500);
        setSearchTimer(timer);
    }

    const onClickDelete = () => {
        deleteOperation(deleteId)
            .then(res => {
                setIsOpen(false)
                dispatch(deleteOperationAction(res.data))
                toast.success('Silindi')
            }).catch(err => {
                toast.error(ENTITY_IS_IN_USE_MESSAGE)
            })
    }
    return (
        <div>
            <div className='mb-1 border-b border-zinc-300'>
                <label className='text-2xl'>
                    İŞLEMLER
                </label>
            </div>
            <div className='flex gap-x-2 py-2 sticky top-0 bg-zinc-50'>
                <Button
                    text={<label className='flex items-center gap-x-1'><GoPlus />Yeni İşlem</label>}
                    variant='green'
                    onClick={() => nav('/operation/add')}
                />
            </div>
            <table className='w-full text-left text-zinc-900 mb-10 text-sm'>
                <thead className='text-xs uppercase tracking-wide sticky top-12 bg-zinc-50'>
                    <tr>
                        <th className='p-2 w-1/12'>Id</th>
                        <th className='p-2 w-3/12'>İşlem Kodu</th>
                        <th className='p-2 w-3/12'>İşlem Adı</th>
                        <th className='p-2 w-4/12'>Açıklama</th>
                        <th className='p-2 w-1/12'>Aksiyon</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className='border-b items-center sticky top-20 bg-zinc-50'>
                        <td className='px-2'>
                            <Input
                                name="id"
                                placeholder='Id...'
                                onChange={e => onChange(e, setSearchParams)}
                            />
                        </td>
                        <td className='px-2'>
                            <Input
                                name="code"
                                placeholder='Desen kodu...'
                                onChange={e => onChange(e, setSearchParams)}
                            />
                        </td>
                        <td className='px-2'>
                            <Input
                                name="name"
                                placeholder='Desen adı...'
                                onChange={e => onChange(e, setSearchParams)}
                            />
                        </td>
                        <td>
                        </td>
                        <td>
                        </td>
                    </tr>
                    {
                        operationPage.content.map((operation, index) => (
                            <tr key={index} className='border-b items-center hover:bg-violet-100 duration-150'>
                                <td className='p-2'># {operation.id} </td>
                                <td className='p-2'>{operation.code} </td>
                                <td className='p-2'>{operation.name}</td>
                                <td className='p-2 '>{operation.description}</td>
                                <td className='p-2 items-center'>
                                    <div className='flex gap-x-3'>
                                        <span className='cursor-pointer hover:scale-125 hover:text-blue-600 duration-150' onClick={() => nav(`/operation/edit/${operation.id}`)}>
                                            <AiFillEdit />
                                        </span>
                                        <span
                                            className='cursor-pointer hover:scale-125 hover:text-red-600 duration-150'
                                            onClick={() => {
                                                setIsOpen(true)
                                                setDeleteId(operation.id)
                                            }}
                                        >
                                            <AiFillDelete />
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
            <LoadMore page={operationPage} pending={pendingApiCall} onLoadMore={onLoadMore} />
            <DeleteModal
                isOpen={isOpen}
                closeModal={() => setIsOpen(false)}
                onClick={onClickDelete}
                pendingApiCall={pendingApiCallDelete}
            />
        </div >
    )
}

export default OperationListPage